/**
 * React component registry.
 * Add new React apps here — they become mountable via data-react-component="ComponentName".
 */
import App from './App';
import MarketApp from './MarketApp';

const COMPONENTS = {
  LiveDashboard: App,
  MarketDashboard: MarketApp,
};

export function getComponent(name) {
  return COMPONENTS[name] || null;
}

export function registerComponent(name, component) {
  COMPONENTS[name] = component;
}
